import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminLayout } from './layouts/AdminLayout';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { TransactionHistoryPage } from './pages/TransactionHistoryPage';
import { AccountRecoveryPage } from './pages/AccountRecoveryPage';
import { BlacklistManagementPage } from './pages/BlacklistManagementPage';
import { CollateralAlertsPage } from './pages/CollateralAlertsPage';
import { CollateralWhitelistPage } from './pages/CollateralWhitelistPage';
import { CompliancePage } from './pages/CompliancePage';
import { ComplianceReportsPage } from './pages/ComplianceReportsPage';
import { CreditFacilityConfigPage } from './pages/CreditFacilityConfigPage';
import { CustomRegistriesPage } from './pages/CustomRegistriesPage';
import { DeployCfWizardPage } from './pages/DeployCfWizardPage';
import { KycInitiationPage } from './pages/KycInitiationPage';
import { ClaimsPage } from './pages/ClaimsPage';
import { LiquidationPage } from './pages/LiquidationPage';
import { MarginAccountsPage } from './pages/MarginAccountsPage';
import { ModuleManagementPage } from './pages/ModuleManagementPage';
import { ModuleDetailPage } from './pages/ModuleDetailPage';
import { OracleManagementPage } from './pages/OracleManagementPage';
import { RiskPage } from './pages/RiskPage';
import { RoleManagementPage } from './pages/RoleManagementPage';
import { StablecoinPoolsPage } from './pages/StablecoinPoolsPage';
import { StablecoinPoolDetailPage } from './pages/StablecoinPoolDetailPage';
import { StressTestingPage } from './pages/StressTestingPage';
import { TokenCompliancePage } from './pages/TokenCompliancePage';
import { TokenDeploymentPage } from './pages/TokenDeploymentPage';
import { TokenEventsPage } from './pages/TokenEventsPage';
import { TokenMintingPage } from './pages/TokenMintingPage';
import { AuditPage } from './pages/AuditPage';
import { BootstrapCfPage } from './pages/BootstrapCfPage';
import { CreditFacilitiesPage } from './pages/CreditFacilitiesPage';
import { AdminMarginAccountDetailPage } from './pages/AdminMarginAccountDetailPage';
import { CreditFacilityDetailPage } from './pages/CreditFacilityDetailPage';
import { AdminAuctionDetailPage } from './pages/AdminAuctionDetailPage';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<AdminLayout />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="credit-facilities" element={<CreditFacilitiesPage />} />
        <Route path="cf/:facilityName" element={<CreditFacilityDetailPage />} />
        <Route path="cf/:facilityName/auction/:auctionId" element={<AdminAuctionDetailPage />} />
        <Route path="transaction-history" element={<TransactionHistoryPage />} />
        <Route path="account-recovery" element={<AccountRecoveryPage />} />
        <Route path="audit" element={<AuditPage />} />
        <Route path="blacklist-management" element={<BlacklistManagementPage />} />
        <Route path="collateral-alerts" element={<CollateralAlertsPage />} />
        <Route path="collateral-whitelist" element={<CollateralWhitelistPage />} />
        <Route path="compliance" element={<CompliancePage />} />
        <Route path="compliance-reports" element={<ComplianceReportsPage />} />
        <Route path="credit-facility-config" element={<CreditFacilityConfigPage />} />
        <Route path="custom-registries" element={<CustomRegistriesPage />} />
        <Route path="deploy-cf-wizard" element={<DeployCfWizardPage />} />
        <Route path="kyc-initiation" element={<KycInitiationPage />} />
        <Route path="claims" element={<ClaimsPage />} />
        {/* Backward-compat: old /kyc-review and /identity links land on the consolidated Claims page */}
        <Route path="kyc-review" element={<Navigate to="/claims" replace />} />
        <Route path="identity" element={<Navigate to="/claims" replace />} />
        <Route path="liquidation" element={<LiquidationPage />} />
        <Route path="liquidation-queue" element={<Navigate to="/liquidation" replace />} />
        <Route path="margin-accounts" element={<MarginAccountsPage />} />
        <Route path="margin-accounts/:accountId" element={<AdminMarginAccountDetailPage />} />
        <Route path="module-management" element={<ModuleManagementPage />} />
        <Route path="module-management/:moduleId" element={<ModuleDetailPage />} />
        <Route path="oracle-management" element={<OracleManagementPage />} />
        <Route path="risk" element={<RiskPage />} />
        <Route path="role-management" element={<RoleManagementPage />} />
        <Route path="stablecoin-pools" element={<StablecoinPoolsPage />} />
        <Route path="stablecoin-pools/:poolId" element={<StablecoinPoolDetailPage />} />
        <Route path="stress-testing" element={<StressTestingPage />} />
        <Route path="token-compliance" element={<TokenCompliancePage />} />
        <Route path="token-deployment" element={<TokenDeploymentPage />} />
        <Route path="token-events" element={<TokenEventsPage />} />
        <Route path="token-minting" element={<TokenMintingPage />} />
        <Route path="bootstrap-cf" element={<BootstrapCfPage />} />
      </Route>
    </Routes>
  );
}
